export var EField;
(function (EField) {
    EField["Token"] = "token";
})(EField || (EField = {}));
